import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  root: {
    paddingLeft: 3,
  },
  userNameRoot: {
    overflow: 'hidden',
  },
  text: {
    marginLeft: 5,
    color: theme.palette.primary.contrastText,
    fontWeight: '600',
  },
  image: {
    height: theme.spacing(6),
    width: theme.spacing(6),
    borderRadius: theme.spacing(6) / 2,
  },
  icon: {
    color: theme.palette.primary.contrastText,
  }
}));

